import React, { useState } from 'react';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useSelector } from 'react-redux';

function validatePrefix(prefix) {
    if (!prefix) return '';
    if (/[^a-z0-9-]/g.test(prefix)) return 'Use only lowercase letters, numbers, and hyphens.';
    if (/^-|-$|--/g.test(prefix)) return 'Hyphens cannot start or end, and consecutive hyphens are not allowed.';
    return '';
}

/**
 * Per-node-group stack picker (multi-image mode): the Redux Stack records for
 * the provider, with free text allowed.
 */
export default function NodeStackField({ provider, value, onChange, disabled, label = 'Node Stack' }) {
    const stacks = useSelector(({ stacks }) => stacks.stack.list) || [];
    const [error, setError] = useState('');

    const providerStacks = stacks.filter(
        s => s.info?.state === 'success' && s.provider === provider
    );

    const optionPrefix = (option) => (typeof option === 'string' ? option : option.data?.prefix || option.name || '');

    const handleChange = (newValue) => {
        const prefix = optionPrefix(newValue) || '';
        setError(validatePrefix(prefix));
        onChange(prefix);
    };

    return (
        <Autocomplete
            freeSolo
            disabled={disabled}
            options={providerStacks}
            getOptionLabel={optionPrefix}
            renderOption={(option) => <span>{optionPrefix(option)}</span>}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    placeholder="Select or enter stack name"
                    variant="outlined"
                    disabled={disabled}
                    error={Boolean(error)}
                    helperText={error}
                />
            )}
            onChange={(event, newValue) => handleChange(newValue)}
            onInputChange={(event, newInputValue, reason) => {
                if (reason === 'input') handleChange(newInputValue);
            }}
            value={value || ''}
            style={{ flex: 1 }}
        />
    );
}

export { validatePrefix };
